/**
 * Created by az on 2017/7/12.
 */
import QbCheckBox from './QbCheckBox';
import QbRadio from './QbRadio';
import QbInput from './QbInput';
import QbSwitcher from './QbSwitcher';

export {QbCheckBox, QbRadio, QbInput, QbSwitcher};